import React from "react";
import { handleLinkTarget } from "../../utils";
export const ButtonSquare = ({ primary = true, label, ...props }) => {
    const openInNewTabValue = props.openinnewtab === "true" ? true : false;
    const hrefTarget = handleLinkTarget(openInNewTabValue);
    return (React.createElement("a", { href: props.href ? props.href : "#", onClick: props.onClick, target: hrefTarget, className: `squaredButton squaredButton--${primary ? "primary" : "secondary"} ${props.classes ? props.classes : ""}`, style: { ...props.style }, ...props }, label));
};
